import React, { useEffect, useState } from 'react';
import NavigationBar from '../../components/NavigationBar/NavigationBar';
import PaginationButtons from '../../components/Common/Pagination';
import { PaymentHistoryItem } from '../../interfaces/payment.interface';
import { fetchPaymentHistory } from './services/Payment.service';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import PaymentHistoryTable from './components/PaymentHistoryTable';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import NoItemsFound from '../../components/NoItemsFound/NoItemsFound';


const Payments = () => {
  const user = useSelector((state: RootState) => state.user.user);
  const [paymentHistory, setPaymentHistory] = useState<PaymentHistoryItem[] | null>(null);
  const [loader, setLoader] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number | null>(null);

  const handleGetPaymentHistory = async () => {
    setLoader(true);
    const response = await fetchPaymentHistory(user?.email || '', currentPage);

    if (response) {
      setPaymentHistory(response.payments);
      setTotalPages(response.totalPages);
    }

    setLoader(false);
  };

  useEffect(() => {
    handleGetPaymentHistory().then();
  }, [user, currentPage]);

  const handlePageChange = (page: string | number) => {
    setCurrentPage(+page);
  };

  return (
    <div>
      <div className="App">
        <NavigationBar />
        <div className="bg-storytan p-4 mx-auto">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 min-h-screen">
            <h2 className="text-left text-4xl mb-4 font-bold text-storyblue">My Payments</h2>
            <>
              {loader ? (
                <LoadingSpinner />
              ) : (
                <>
                  {paymentHistory && paymentHistory.length > 0 ? (
                    <PaymentHistoryTable
                      paymentHistory={paymentHistory}
                    />
                  ) : (
                    <NoItemsFound message="No Payments Found" />
                  )}
                </>
              )}
              <div className="flex justify-end mt-4 gap-2">
                {totalPages && totalPages > 1 && (
                  <PaginationButtons
                    totalPages={totalPages}
                    currentPage={currentPage}
                    handlePageChange={handlePageChange}
                  />
                )}
              </div>
            </>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Payments;
